import api from "../../api/api";
import { getCountryCode } from "../../common/contactDetails";

export const GET_COUNTRIES = 'GET_COUNTRIES';
export const GET_STATES = 'GET_STATES';
export const GET_PREF_CONTACT_METHOD = 'GET_PREF_CONTACT_METHOD';
export const GET_DEPARTMENT = 'GET_DEPARTMENT';
export const GET_POSITION = 'GET_POSITION';
export const GET_RANK = 'GET_RANK';
export const GET_UNIT_LOCATION = 'GET_UNIT_LOCATION';
export const GET_TITLE_LIST = 'GET_TITLE_LIST';
export const GET_UNIT = 'GET_UNIT'

export function getCountries(countries) {
    return {
        type: GET_COUNTRIES,
        countries: countries
    }
}

export function getStates(states) {
    return {
        type: GET_STATES,
        states: states
    }
}

export function getPrefContactMethod(states) {
    return {
        type: GET_PREF_CONTACT_METHOD,
        states: states
    }
}

export function getDepartment(states) {
    return {
        type: GET_DEPARTMENT,
        states: states
    }
}

export function getPosition(states) {
    return {
        type: GET_POSITION,
        states: states
    }
}

export function getRank(states) {
    return {
        type: GET_RANK,
        states: states
    }
}

export function getUnitLocation(unit) {
    return {
        type: GET_UNIT_LOCATION,
        data: unit
    }
}
export function getUnit(unitLocation) {
    return {
        type: GET_UNIT,
        data: unitLocation
    }
}

export function getTitleList(states) {
    return {
        type: GET_TITLE_LIST,
        states: states
    }
}


// since country and state are usually combined together, just fetchen them together
export function fetchCountryStates(contactDetails, country) {
    const countryCode = getCountryCode(country);
    return dispatch => {
        dispatch(fetchCountries(contactDetails));
        dispatch(fetchStates(contactDetails, countryCode));
    }
}

// recieve the whole contactDetails as an argument, check if the couontries is empty, then fetch the data
export function fetchCountries(contactDetails) {
    const countryExisted = contactDetails === null || contactDetails.countries.length !== 0
    return async dispatch => {
        if (!countryExisted) {
            const url = `api/ReferenceDataService/RetrieveCountry`;
            return api.request(url, 'get')
                .then(response => {
                    dispatch(dispatch(getCountries(response.ReferenceDataCollection)));
                    return response.ReferenceDataCollection;
                })
                .catch(err => err)
        }
    }
}

// recieve the whole contactDetails as an argument, check if the needed state is empty, then fetch the data
export function fetchStates(contactDetails, countryId) {
    // by default, if doesn't add any countries code, then the country is Australia
    countryId = countryId === undefined ? 13 : countryId;
    const stateExisted = contactDetails === null || contactDetails.states[countryId] !== undefined;
    return async dispatch => {
        if (!stateExisted) {
            const updatedState = { ...contactDetails.states };
            const url = `api/ReferenceDataService/RetrieveStatesOfCountry?id=${countryId}`;
            return api.request(url, 'get').then(response => {
                updatedState[countryId] = response.ReferenceDataCollection;
                dispatch(getStates(updatedState));
                // return state as value
                return response.ReferenceDataCollection;
            });
        }
    }
}